import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { href: '/', label: 'Accueil' },
    { href: '/restaurant', label: 'Le Restaurant' },
    { href: '/reservation', label: 'Réserver' },
    { href: '/commander', label: 'Commander' },
    { href: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="glass-nav border-b border-stone-100" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
            <span className="font-['Playfair_Display'] text-2xl font-bold text-[#1C1917]">
              NotaBene <span className="text-[#C62E2E]">Sympho</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
                className={`font-medium transition-colors ${
                  isActive(link.href)
                    ? 'text-[#C62E2E]'
                    : 'text-[#57534E] hover:text-[#1C1917]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:+3265950649"
              className="flex items-center gap-2 text-[#57534E] hover:text-[#C62E2E] transition-colors"
              data-testid="nav-phone"
            >
              <Phone className="w-4 h-4" />
              <span className="font-medium">065 95 06 49</span>
            </a>
            <Link to="/commander">
              <Button
                className="bg-[#C62E2E] hover:bg-[#a02424] text-white rounded-full px-6"
                data-testid="nav-order-btn"
              >
                Commander
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-btn"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-white border-t border-stone-100" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setIsOpen(false)}
                className={`block py-2 font-medium ${
                  isActive(link.href)
                    ? 'text-[#C62E2E]'
                    : 'text-[#57534E]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-4 border-t border-stone-100">
              <a
                href="tel:+3265950649"
                className="flex items-center gap-2 text-[#57534E] py-2"
              >
                <Phone className="w-4 h-4" />
                <span>065 95 06 49</span>
              </a>
              <Link to="/commander" onClick={() => setIsOpen(false)}>
                <Button className="w-full mt-3 bg-[#C62E2E] hover:bg-[#a02424] text-white rounded-full">
                  Commander
                </Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
